<!-- ========== Left Sidebar Start ========== -->
<div class="vertical-menu " id="dvSideBar">

    <ng-template #loading>
  <div class="text-muted p-2">Loading menu...</div>
</ng-template>




    <!--- Sidemenu -->
  
    <div id="sidebar-menu" >
      <!-- Left Menu Start -->
      <ul class="metismenu list-unstyled" id="side-menu">
        @for (item of menuItems; track $index) {
        <ng-container>
          @if(item.isTitle){
          <li class="menu-title">{{ item.label | translate }}</li>
          }@else if (!item.isTitle && !item.isLayout) {
          <li>
            @if(hasItems(item)){
            <a href="javascript:void(0);" class="is-parent"
              [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}">
              <i class="{{ item.icon }}"></i>
              <span> {{ item.label | translate }}</span>
              @if(item.badge){
              <span class="badge rounded-pill float-end badge-soft-{{item.badge.variant}} text-danger">{{item.badge.text
                | translate}}</span>}
            </a>
            }@else{

            <a [routerLink]="item.link" class="side-nav-link-ref d-flex" routerLinkActive="active">
              <!-- <a href="#" (click)="onMenuClick(item.id)" class="side-nav-link-ref"> -->
              @if(item.icon){
              <i class="{{ item.icon }} " style="font-size: 16px"></i>}
              <span class="text-nowrap"> {{ item.label | translate }}</span>
              @if(item.badge){
              <span class="badge rounded-pill badge-soft-{{item.badge.variant}} float-end">{{item.badge.text
                | translate}}</span>}
            </a>}

          </li>
          }
        </ng-container>
        }
      </ul>

      <div class="card sidebar-alert border-0 text-center mx-4 mb-0 mt-5">
        <!-- <div class="card-body">
          <img src="assets/images/giftbox.png" alt="">
          <div class="mt-4">
            <h5 class="alertcard-title font-size-16">Unlimited Access</h5>
            <p class="font-size-13">Upgrade your plan from a Free trial, to select ‘Growth ERP Business Plan’.</p>
            <a href="javascript:void(0);" class="btn btn-primary mt-2">Upgrade Now</a>
          </div>
        </div> -->
      </div>
    </div>
    <!-- Sidebar -->

</div>
<!-- Left Sidebar End -->